export const SESSION_KEYS = {
  PAGE_VIEW_TYPE: 'pageViewType',
};

export const STORAGE_KEYS = {
  COUNTDOWN_TIMER: 'countdownTimer',
  GROUPS: 'groups',
  BLOCK_PAGE_SELECTED_BUNDLE: 'blockPageSelectedBundle',
  CUSTOM_BLOCK_PAGE_BACKGROUND: 'customBlockPageBackground',
  BLOCK_PAGE_DAILY_VISITS: 'blockPageDailyVisits',
  HAS_RATED: 'hasRated',
  FIRST_APP_OPEN_SENT: 'firstAppOpenSent',
  // persists first install time to detect returning users after uninstall and reinstall
  LAST_KNOWN_INSTALLED_TIME: 'lastKnownInstalledTime',
  WHATS_NEW_GROUPS_DISMISSED: 'whatsNewGroupsDismissed',
};
